import React, { Component } from 'react'
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';

import IconPng from 'atoms/IconPng';
import { TxtLink } from 'atoms/Texts';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { RoundedWrapper } from './styles'

const ic_arrow_left = require('App/assets/images/ic_arrow_left.png');

class DetailDailyLoadingPoint extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reportUri: null,
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
  }

  componentDidUpdate() {
    const { REPORT_URL } = process.env
    const { match: { params: { ids } }, viewState: { isLoading } } = this.props

    if (isLoading) {
      this.setState({ reportUri: `${REPORT_URL}DAILY_ELEVATIONS&ID=${ids}` }, () => {
        this.props.toggleIsLoading(false)
      })
    }
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 334}px` : `${h - 250}px`
  }

  render() {
    const { theme, history: { goBack }, viewState: { isLoading } } = this.props
    const { reportUri } = this.state
    return (
      <div>
        <TxtLink weight={'bold'} color={theme.mocaPurple} size={'14'} showPointer onClick={() => goBack()}>
          <IconPng srcIcon={ic_arrow_left} showPointer={true} mr={'8px'} mb={'3px'} size={'auto'} h={'13'} />
          Back to Daily Loading Point List
        </TxtLink>
        {!isLoading &&
          <RoundedWrapper>
            <div className="mb-3">
              <Iframe
                url={reportUri}
                width="100%"
                height={this.getIframeHeight()}
                display="initial"
                position="relative"
                frameBorder="0" />
            </div>
          </RoundedWrapper>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DetailDailyLoadingPoint)
  )
);